import { FiShield, FiX } from "react-icons/fi";
import styles from "./BlockConfirmModal.module.css";

const BlockConfirmModal = ({ userName, onConfirm, onCancel }) => (
  <div className={styles.overlay} onClick={onCancel}>
    <div className={styles.box} onClick={(e) => e.stopPropagation()}>
      <div className={styles.iconWrap}>
        <FiShield size={28} />
      </div>
      <h3 className={styles.title}>Block {userName}?</h3>
      <p className={styles.desc}>
        Blocked contacts can no longer send you messages.
        You can unblock them anytime from settings.
      </p>
      <div className={styles.btns}>
        <button className={styles.cancel} onClick={onCancel}>Cancel</button>
        <button className={styles.confirm} onClick={onConfirm}>Block</button>
      </div>
    </div>
  </div>
);

export default BlockConfirmModal;
